import { useFormContext } from './useFormContext';
export const useChangeMultipleValues = (callback) => {
  const formContext = useFormContext();
  return (_, fieldValue) => {
    return formContext.setValues((prevValues) => {
      return callback(fieldValue, prevValues);
    });
  };
};
